import { CssBaseline, Zoom } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ptBR } from '@mui/x-date-pickers/locales';
import { defineAbilityFor } from 'auth/ability';
import { AbilityContext, useAbility } from 'contexts/AbilityContext';
import useAuth from 'hooks/useAuth';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutes } from 'react-router-dom';
import router from 'router';
import { getPermissionByLoggedUser } from 'store/ducks/Permissions/service';
import { Actions, Subjects } from 'types/subjects';
import { axiosEndPoint } from 'utils/axios';

import AppInit from './components/AppInit';
import ThemeProvider from './theme/ThemeProvider';

const App = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const content = useRoutes(router);
  const ability = useAbility();
  const auth = useAuth();

  // useEffect(() => {
  //   axiosEndPoint.interceptors.response.use(
  //     (response) => {
  //       return response;
  //     },
  //     async (error: AxiosError) => {
  //       if (error.response?.status === 401) {
  //         if (error.message !== 'Request failed with status code 401') {
  //           enqueueSnackbar(error.message, {
  //             variant: 'error',
  //             anchorOrigin: {
  //               vertical: 'top',
  //               horizontal: 'right'
  //             },
  //             TransitionComponent: Zoom
  //           });
  //         }
  //         auth.logout();
  //       } else if (error.response?.status === 403) {
  //         auth.logout();
  //         // const currentRefreshToken =
  //         //   window.localStorage.getItem('refreshToken');

  //         // const response = await axiosEndPoint.post<refreshToken>(
  //         //   '/refreshToken',
  //         //   {
  //         //     REFRESHTOKEN: currentRefreshToken
  //         //   }
  //         // );

  //         // if (response.status === 200) {
  //         //   localStorage.setItem('accessToken', response.data.token);

  //         //   const config = error.config;
  //         //   config.headers.Authorization = `Bearer ${response.data.token}`;
  //         //   return axiosEndPoint.request(config);
  //         // } else if (response.status === 400) {
  //         //   enqueueSnackbar(error.message, {
  //         //     variant: 'error',
  //         //     anchorOrigin: {
  //         //       vertical: 'top',
  //         //       horizontal: 'right'
  //         //     },
  //         //     TransitionComponent: Zoom
  //         //   });
  //         //   auth.logout();
  //         // } else {
  //         //   auth.logout();
  //         // }
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  // }, [auth]);

  axiosEndPoint.interceptors.request.use(
    (request) => {
      const userData = window.localStorage.getItem('accessToken');

      request.headers.Authorization = `${userData}`;
      return request;
    },
    (error) => {
      console.error('error save token', error);
    }
  );

  // axiosEndPoint.interceptors.response.use(
  //   (response) => {
  //     return response;
  //   },
  //   async (error) => {
  //     if (error.response?.status === 403) {
  //       auth.logout();
  //     }
  //     if (error.response?.status === 400 || error.response?.status === 401) {
  //       enqueueSnackbar(error.response?.data?.message, {
  //         variant: 'error',
  //         anchorOrigin: {
  //           vertical: 'top',
  //           horizontal: 'right',
  //         },
  //         TransitionComponent: Zoom,
  //       });

  //       auth.logout();
  //     }
  //     return error;
  //   }
  // );

  const fetchPermissions = async () => {
    try {
      const response = await getPermissionByLoggedUser();
      defineAbilityFor(response.permissions, response.isAdmin);

      let permissions: { action: Actions; subject: Subjects }[] = [];

      if (response.isAdmin) {
        permissions = [{ action: 'manage', subject: 'all' }];
      } else {
        permissions = response.permissions.map((permission) => ({
          action: permission.action.toLowerCase() as Actions,
          subject: permission.subject.toLowerCase() as Subjects,
        }));
      }

      ability.update(permissions);
    } catch (_error) {
      auth.logout();
      enqueueSnackbar(t('Fail to recovery permissions'), {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        TransitionComponent: Zoom,
      });
    }
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      fetchPermissions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  return (
    <ThemeProvider>
      <LocalizationProvider
        localeText={
          ptBR.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <AbilityContext.Provider value={ability}>
          <CssBaseline />
          {auth.isInitialized ? content : <AppInit />}
        </AbilityContext.Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};
export default App;
